var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[_vm.imageClass, _vm.imageState],style:(_vm.computedStyle),attrs:{"data-width":_vm.imageWidth,"data-height":_vm.imageHeight,"data-state":_vm.imageState}})}
var staticRenderFns = []

export { render, staticRenderFns }